import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tw-flex tw-w-full tw-h-full tw-flex-col" }
const _hoisted_2 = { class: "tw-p-[30px] tw-w-fit tw-max-h-[95px] tw-h-[95px]" }
const _hoisted_3 = {
  id: "chr-sheading-score",
  class: "tw-text-[18px] tw-text-[#211F58] tw-font-semibold tw-mt-[4px]"
}
const _hoisted_4 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-full"
}
const _hoisted_5 = {
  key: 1,
  class: "tw-flex tw-flex-1 tw-overflow-hidden tw-justify-center tw-w-full tw-h-full"
}
const _hoisted_6 = { class: "tw-mt-[9px]" }

import CyberScoreChart from "./cyberScoreChart.vue";
import { getComponentUiText } from "@/utils/utilities";

export default /*#__PURE__*/_defineComponent({
  __name: 'score',
  props: {
  color: {
    type: String,
    default: "#F7553C",
  },
  colorDefault: {
    type: String,
    default: "#FEE5E2",
  },
  currentScore: {
    type: Number,
    default: 0,
  },
  pcntScore: {
    type: Number,
    default: 0,
  },
  loading: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
            "app-component-assessments-question-type-2-icon-tooltip-score-1",
          )), 1)
    ]),
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(CyberScoreChart, {
              "current-score": __props.currentScore,
              "pcnt-score": __props.pcntScore,
              color: __props.color,
              "color-default": __props.colorDefault
            }, null, 8, ["current-score", "pcnt-score", "color", "color-default"])
          ])
        ]))
  ]))
}
}

})